import React from 'react';
import { Typography, Box, AppBar } from '@mui/material';
import images from '../../assets/images';

const Restricted = () => {
  return (
    <Box>
      <AppBar
        position="sticky"
        data-testid="restricted-top-bar"
        sx={{ width: '100%', zIndex: (theme) => theme.zIndex.drawer + 1, textAlign: 'center' }}
      >
        <Typography variant="h3" data-testid="jimbo-title">
          Jimbo
        </Typography>
      </AppBar>
      <Box data-testid="restricted-message" textAlign="center" sx={{ marginTop: 20 }}>
        <img src={images.warning} height="80" width="80" alt="Hi" data-testid="hi-image" />
        <Typography variant="h5" sx={{ fontSize: '50px' }}>
          Access restricted
        </Typography>
        <Typography>You are trying to use an external email address to login</Typography>
        <Typography>Please try again using a JimmyBrings account</Typography>
      </Box>
      <Box sx={{ position: 'fixed', bottom: 0, right: 0, zIndex: 100 }}>
        <img src={images.scott} alt="Scott" height="400" width="400" data-testid="scott-image" />
      </Box>
    </Box>
  );
};

export default React.memo(Restricted);
